import { createSelector, select } from '@ngrx/store';
import { pipe } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  sessionProfileFeature,
  UserProfile,
} from '../reducers/session-profile.reducer';

export const userProfileSelector = sessionProfileFeature.selectUserProfile;
export const selectUserProfile = pipe(
  select(userProfileSelector),
  filter((userProfile) => !!userProfile),
);

export const userRegionCodeSelector = createSelector(
  userProfileSelector,
  (userProfile: UserProfile) => userProfile?.regionCode,
);
export const selectUserRegionCode = pipe(
  selectUserProfile,
  map((userProfile: UserProfile) => userProfile.regionCode),
);

export const selectUserRegionZip = pipe(
  selectUserProfile,
  map((userProfile: UserProfile) => userProfile.regionZip),
);

export const userPartnerCodeSelector = createSelector(
  userProfileSelector,
  (userProfile: UserProfile) => userProfile?.partnerCode,
);

export const userPartnerLogoUrlSelector = createSelector(
  userProfileSelector,
  (userProfile: UserProfile) => userProfile?.partnerLogoUrl,
);

export const userOnboardingLevelSelector = createSelector(
  userProfileSelector,
  (userProfile: UserProfile) => userProfile?.onboarding_level,
);

export const userOnboardingConsentSelector = createSelector(
  userProfileSelector,
  (userProfile: UserProfile) => userProfile?.onboarding_consent,
);

export const userInterestWizardStateSelector = createSelector(
  userProfileSelector,
  (userProfile: UserProfile) =>
    userProfile && (userProfile?.interest_wizard_state || 'NOT_STARTED'),
);
